import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import {
  EnrichedSwarovskiProductFrontend,
  EnrichedSwarovskiProductVariantFrontend,
  type TranslatedValue,
} from "@swo/storefront";
import { pipe } from "fp-ts/lib/function";
import { nonEmptyArray, option } from "fp-ts";
import { css } from "@emotion/react";
import { FONTS, fontSize } from "../../../styles/fonts";
import React from "react";
import { responsivePlainTextStyles } from "../../../styles/text-styles";
import { NonEmptyArray } from "fp-ts/NonEmptyArray";
import { T } from "../../../components/T";
export const ProductDetailPageDeliveryPackage: ReactTFC<{
  headline: TranslatedValue;
  elements: NonEmptyArray<string>;
}> = props => {
  return (
    <>
      <span
        css={[
          FONTS.SwarovskiFutura500,
          fontSize.x25,
          css`
            display: block;
            margin-bottom: 12px;
          `,
        ]}
      >
        <T>{props.headline}</T>
      </span>
      <ul>
        {props.elements.map(p => (
          <li
            key={p}
            css={[
              FONTS.SwarovskiFutura300,
              responsivePlainTextStyles,
              css`
                &:before {
                  display: inline-block;
                  content: "– ";
                  width: 1em;
                  //margin-left: -1em;
                }
              `,
            ]}
          >
            <span>{p}</span>
          </li>
        ))}
      </ul>
    </>
  );
};
